module.exports = __webpack_public_path__ + "img/logo.7cb7a603.png";